import { useEffect, useMemo, useState } from "react";
import * as tf from "@tensorflow/tfjs";
import { Storage } from "aws-amplify";
import { createBreakpoint } from "react-use";

const useBreakpoint = createBreakpoint({ bigEnough: 1200, tooSmall: 1199 });

export function useLoadModel() {
  const breakpoint = useBreakpoint();
  const [isModelLoaded, setModalLoaded] = useState<boolean>(false);
  const [backendType, setBackendType] = useState<string>();
  const [decoder, setDecoder] = useState<any>();
  const [minHeight, setMinHeight] = useState<string>();
  const [progress, setProgress] = useState<number>(0);

  async function getDownloadLink(key: string) {
    const signedURL = await Storage.get(key, {
      level: "public",
    });
    return String(signedURL);
  }

  async function initializeModel(downloadLink: any) {
    const decoder = await tf.loadGraphModel(downloadLink, {
      weightUrlConverter: getDownloadLink,
      onProgress: (progress) => {
        setProgress(progress * 100);
      },
    });
    return decoder;
  }

  async function loadModel() {
    const modelsList = await tf.io.listModels();

    if ("indexeddb://factorecg_model" in modelsList) {
      const model = await tf.loadGraphModel("indexeddb://factorecg_model");
      setModalLoaded(true);
      setDecoder(model);
      setBackendType(tf.getBackend());
      console.log("loaded model from local storage");
    } else {
      getDownloadLink("model.json").then((signedURL) => {
        tf.enableProdMode();
        initializeModel(signedURL).then((model) => {
          setModalLoaded(true);
          setDecoder(model);
          setBackendType(tf.getBackend());
          console.log("loaded model from server");
          model.save("indexeddb://factorecg_model");
        });
      });
    }
    //   console.log(JSON.stringify(modelsList));
    // console.log("indexeddb://factorecg_model" in modelsList);
    // await tf.io.removeModel("indexeddb://factorecg_model");

    // const modelsList2 = await tf.io.listModels();
    // console.log(JSON.stringify(modelsList2));
    // console.log("indexeddb://factorecg_model" in modelsList2);
    //const model = await tf.loadGraphModel("indexeddb://factorecg_model");
    //console.log(model);
    //return model;
  }

  useEffect(() => {
    setMinHeight(window.innerHeight.toString());

    if (breakpoint === "bigEnough") {
      loadModel();
    }
  }, [breakpoint]);

  return useMemo(
    () => ({
      breakpoint,
      minHeight,
      decoder,
      isModelLoaded,
      backendType,
      progress,
    }),
    [breakpoint, minHeight, decoder, isModelLoaded, backendType, progress]
  );
}
